import React, { useEffect, useState } from "react";
import { Alert, AlertIcon, Box, Text } from "@chakra-ui/react";
import { fetchNotices } from "../api";

export default function NoticeBanner() {
  const [notices, setNotices] = useState([]);

  useEffect(() => {
    const controller = new AbortController();
    let active = true;
    const load = async () => {
      try {
        const data = await fetchNotices({ signal: controller.signal });
        if (active) setNotices(data);
      } catch (error) {
        if (active && error.name !== "AbortError") {
          console.error("공지사항 조회 실패:", error);
        }
      }
    };
    load();
    return () => {
      active = false;
      controller.abort();
    };
  }, []);

  if (notices.length === 0) return null;

  return (
    <Box as="section" aria-label="공지사항" width="full" maxW="1000px" mb={4}>
      {notices.map((notice, index) => (
        <Alert
          key={notice.id}
          status="info"
          rounded="md"
          shadow="sm"
          alignItems="flex-start"
          mt={index ? 2 : 0}
        >
          <AlertIcon mt="1" />
          <Box minW="0" overflowWrap="anywhere">
            <Text fontWeight="bold">{notice.title}</Text>
            <Text fontSize="sm" whiteSpace="pre-wrap">
              {notice.content}
            </Text>
          </Box>
        </Alert>
      ))}
    </Box>
  );
}
